import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useState } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAsset, FleetAssetDocumentList, FleetAssetDocumentType } from '../../../types/fleet';
import { StyledTooltip } from '../../ui/StyledTooltip';
import { useFleetAssetDocuments } from '../hooks/useFleetAssetDocuments';
import { useFleetAssets } from '../hooks/useFleetAssets';
import FleetAssetDocumentModal from './FleetAssetDocumentModal';

type Props = Readonly<{
  asset: FleetAsset;
  documents?: FleetAssetDocumentList;
}>;

function FleetAssetDocuments({ asset, documents }: Props) {
  const { theme } = useStyles();
  const { onReload } = useFleetAssets();
  const [selectedDocument, setSelectedDocument] = useState<FleetAssetDocumentType | undefined>(undefined);
  const { emissionsTest, insurancePolicy, vehicleRegistration } = useFleetAssetDocuments(documents);

  return (
    <>
      <FlexRow gap={theme.sizing.scale200}>
        <StyledTooltip
          content="Póliza"
          placement="top"
          showArrow={false}
          ignoreBoundary
        >
          <Button
            kind="tertiary"
            size="mini"
            shape="square"
            onClick={() => {
              setSelectedDocument(FleetAssetDocumentType.insurancePolicy);
            }}
          >
            <MaterialIcon
              name="article"
              size={theme.sizing.scale700}
              color={insurancePolicy.color}
            />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content="Tarjeta de circulación"
          placement="top"
          showArrow={false}
          ignoreBoundary
        >
          <Button
            kind="tertiary"
            size="mini"
            shape="square"
            onClick={() => {
              setSelectedDocument(FleetAssetDocumentType.vehicleRegistration);
            }}
          >
            <MaterialIcon
              name="article"
              size={theme.sizing.scale700}
              color={vehicleRegistration.color}
            />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content="Verificación vehicular"
          placement="top"
          showArrow={false}
          ignoreBoundary
        >
          <Button
            kind="tertiary"
            size="mini"
            shape="square"
            onClick={() => {
              setSelectedDocument(FleetAssetDocumentType.emissionsTest);
            }}
          >
            <MaterialIcon
              name="article"
              size={theme.sizing.scale700}
              color={emissionsTest.color}
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      {!!selectedDocument && (
        <FleetAssetDocumentModal
          documents={documents}
          isOpen
          onClose={(update) => {
            if (update) {
              onReload();
            }
            setSelectedDocument(undefined);
          }}
          selectedAsset={asset}
          selectedDocument={selectedDocument}
        />
      )}
    </>
  );
}

export default FleetAssetDocuments;
